"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReverseGeocodeQuerySchema = exports.AddressSuggestionsResponseSchema = exports.AddressSuggestionsQuerySchema = exports.AddressLocationSchema = exports.coordTupleSchema = exports.coordSchema = void 0;
const zod_1 = require("zod");
// Array (not z.tuple) — Azure function-calling + Mastra Studio reject items-as-array tuple
// schemas. .finite() rejects NaN/Infinity; .refine() enforces lng/lat bounds so a swapped
// pair or a parsing-error 0 cannot reach routing.
exports.coordSchema = zod_1.z
    .array(zod_1.z.number().finite())
    .length(2)
    .refine(([lng, lat]) => lng >= -180 && lng <= 180 && lat >= -90 && lat <= 90, {
    message: 'coordinate out of range — lng must be in [-180,180], lat in [-90,90]',
})
    .describe('A pair of numbers, longitude first then latitude (two separate values, not one field)');
/** `coordSchema`, typed as a `[lng, lat]` tuple after parsing. */
exports.coordTupleSchema = exports.coordSchema.transform(([lng, lat]) => [lng, lat]);
/** An address suggestion or reverse-geocoded address. */
exports.AddressLocationSchema = zod_1.z.object({
    displayName: zod_1.z.string(),
    lat: zod_1.z.number(),
    lon: zod_1.z.number(),
});
const ADDRESS_SEARCH_MIN_QUERY_LENGTH = 3;
exports.AddressSuggestionsQuerySchema = zod_1.z.object({
    q: zod_1.z.string().trim().min(ADDRESS_SEARCH_MIN_QUERY_LENGTH),
});
exports.AddressSuggestionsResponseSchema = zod_1.z.object({
    addressSuggestions: zod_1.z.array(exports.AddressLocationSchema),
});
exports.ReverseGeocodeQuerySchema = zod_1.z.object({
    lat: zod_1.z.string().min(1).pipe(zod_1.z.coerce.number().min(-90).max(90)),
    lon: zod_1.z.string().min(1).pipe(zod_1.z.coerce.number().min(-180).max(180)),
});
//# sourceMappingURL=geo.js.map